// Import 3rd-party dependencies
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { switchMap } from 'rxjs/operators';
import { SubSink } from 'subsink';

// Import project-specific dependencies
import { EnterpriseSearchService, ISearchResultItem } from '@app/services/enterprise-search/enterprise-search.service';
import { PeopleService } from '@app/services/people/people.service';
import { RECENT_SHARED_FILES_COMPONENT_CONSTS } from '@app/config/constants';

@Component({
  selector: 'app-recent-shared-files',
  templateUrl: './recent-shared-files.component.html',
  styleUrls: ['./recent-shared-files.component.css']
})
export class RecentSharedFilesComponent implements OnInit, OnDestroy {
  private subs: SubSink;

  // Class attributes
  fs: number;
  ls: number;
  reCounter: number;
  linksPerPage: number;

  consts = RECENT_SHARED_FILES_COMPONENT_CONSTS;
  insightsArr: ISearchResultItem[] = [];

  constructor(
    private eService: EnterpriseSearchService,
    private peopleService: PeopleService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    // Initialization
    this.fs = 0;
    this.ls = 5;
    this.reCounter = 1;
    this.subs = new SubSink();
    this.linksPerPage = this.consts.NUMBER_OF_LINKS;

    this.subs.sink = this.peopleService.currentUser$
      .pipe(switchMap((user) => this.eService.getInsights(user.mail)))
      .subscribe((insights) => {
        this.insightsArr = insights;
      });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  next(): void {
    this.fs = 5;
    this.ls = this.fs + 5;
    this.reCounter++;
  }

  pre(): void {
    if (this.fs >= 5) {
      this.fs -= 5;
    }

    if (this.ls >= 10) {
      this.ls -= 5;
    }

    this.reCounter--;
  }

  // open link in new tab
  openLink(url: string): void {
    window.open(url, '_blank');
  }

  // copy link
  openSnackBar(): void {
    this._snackBar.open(this.consts.MESSAGE_COPY_LINK, undefined, {
      duration: this.consts.SNACKBAR_DURATION
    });
  }
}
